module.exports = __webpack_public_path__ + "b4a7709bed0ce4da3ad89c6f7ff025f4.png";